export function pluralize(word: string, count?: number) {
  if (!word || word === "") return "";
  if (typeof count === "undefined") return word;
  if (count < 0) return word;
  if (count === 1) return word;
  if (word.match(/(ch|ss|x)$/i)) return `${word}es`;
  return `${word}s`;
}
